import styled from 'styled-components';
import Slider from 'react-slick';

import { Divider, Grid, IconButton, Typography } from '@material-ui/core';

export const SlickSlider = styled(Slider)`
  border-radius: 10px;
  .slick-prev,
  .slick-next {
    top: 93%;
    color: ${({ theme }) => theme.palette.primary.main};
    &:before {
      color: ${({ theme }) => theme.palette.primary.main};
    }
    @media only screen and (max-width: 380px) {
      top: 88%;
    }
  }
  .slick-next {
    right: 10px;
    font-size: 20px;
    z-index: 2;
  }
  .slick-prev {
    left: 10px;
    font-size: 20px;
    z-index: 1;
  }
  .slick-dots {
    bottom: 10px;
    z-index: 2;
    width: auto;
    text-align: center;
    left: 45%;
    @media only screen and (max-width: 992px) {
      left: 40%;
    }
  }
  .slick-dots li button:before {
    color: white;
    opacity: 1;
    font-size: 10px;
  }
  .slick-dots li.slick-active button:before {
    color: ${({ theme }) => theme.palette.primary.main};
    opacity: 1;
  }
  .slick-list {
    margin: 0 5px;
  }
`;

export const Image = styled.img`
  cursor: pointer;
  width: auto;
  margin: 0 auto;
  height: 350px;
  border-radius: 10px;
  @media only screen and (max-width: 1550px) {
    height: 330px;
  }
  @media only screen and (max-width: 1500px) {
    height: 305px;
  }
  @media only screen and (max-width: 1400px) {
    height: 290px;
  }
  @media only screen and (max-width: 1300px) {
    height: 270px;
  }
  @media only screen and (max-width: 1200px) {
    height: 255px;
  }
  @media only screen and (max-width: 1120px) {
    height: 230px;
  }
  @media only screen and (max-width: 992px) {
    height: 210px;
  }
  @media only screen and (max-width: 600px) {
    height: 200px;
    width: 100%;
  }
  @media only screen and (max-width: 380px) {
    height: 200px;
  }
`;

export const MiniBanner = styled.div`
  color: ${({ theme }) => theme.palette.secondary.main};
  cursor: pointer;
  display: flex;
  background: white;
  /* border: 1px solid rgba(97 97 97 / 30%); */
  border-radius: 5px;
  padding: 10px 10px 0;
  box-shadow: none;
  &:hover {
    color: white;
    transition: 0.7s;
    background: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const MiniBannerImg = styled.img`
  object-fit: contain;
  width: auto;
  height: 120px;
  @media only screen and (max-width: 992px) {
    width: 45%;
    height: 90px;
  }
  @media only screen and (max-width: 600px) {
    width: 58%;
    height: 120px;
  }
  @media only screen and (max-width: 480px) {
    width: 32%;
    height: 120px;
  }
`;

export const MiniBannerText = styled(Typography)`
  line-height: 1.2;
  width: 60%;
  font-size: 22px;
  @media only screen and (max-width: 1280px) {
    font-size: 22px;
    line-height: 1.5;
  }
  @media only screen and (max-width: 992px) {
    font-size: 22px;
    line-height: 1.5;
  }
`;

export const MiniBannersArea = styled(Grid)`
  .MuiGrid-item {
    padding: 24px 5px 24px 10px;
    @media only screen and (max-width: 600px) {
      padding: 10px 20px 10px 20px;
    }
  }
  margin: 0 0 5px;
`;

export const WelcomeBanner = styled.div`
  /* border: 1px solid rgba(97 97 97 / 30%); */
  box-shadow: none;
  border-radius: 5px;
  padding: 5px 10px 15px;
  background: white;
  margin: ${({ margin }) => (margin ? `0 ${margin}px` : '0 15px')};
  @media only screen and (max-width: 600px) {
    margin: 0 8px 15px !important;
  }
`;

export const WelcomeText = styled(Typography)`
  font-size: 21px;
  color: ${({ theme }) => theme.palette.secondary.main};
  padding-top: 10px;
  padding-left: 10px;
  @media only screen and (max-width: 992px) {
    font-size: 16px;
  }
`;

export const CurrentDate = styled(Typography)`
  text-align: center;
  font-size: 15px;
  color: ${({ theme }) => theme.palette.secondary.main};
  @media only screen and (max-width: 992px) {
    font-size: 10px;
  }
  @media only screen and (max-width: 380px) {
    font-size: 10px;
  }
`;

export const CurrentTime = styled(Typography)`
  text-align: center;
  line-height: 0.6;
  margin-top: 20px;
  font-size: 55px;
  color: ${({ theme }) => theme.palette.secondary.main};
  @media only screen and (max-width: 1280px) {
    font-size: 40px;
  }
  @media only screen and (max-width: 992px) {
    font-size: 28px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 45px;
  }
  @media only screen and (max-width: 480px) {
    font-size: 32px;
  }
  @media only screen and (max-width: 380px) {
    font-size: 24px;
  }
`;

export const CurrentTemperature = styled(Typography)`
  margin: 15px 0;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 20px;
  svg {
    margin-right: 5px;
  }
`;

export const CurrentLocation = styled(Typography)`
  text-align: center;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.secondary.main};
  @media only screen and (max-width: 992px) {
    font-size: 8px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
  @media only screen and (max-width: 480px) {
    font-size: 12px;
  }
`;

export const BoxTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BirthDayTitle = styled(Typography)`
  font-size: 21px;
  color: ${({ theme }) => theme.palette.secondary.main};
  @media only screen and (max-width: 992px) {
    font-size: 16px;
  }
`;

export const List = styled.ul`
  text-decoration: none;
  list-style: none;
  padding: 0;
  color: ${({ theme }) => theme.palette.secondary.main};
  height: 130px;
  overflow-x: auto;
  margin: 5px 0 0;
  li {
    margin-bottom: 5px;
    svg {
      color: ${({ theme }) => theme.palette.primary.main};
      margin-right: 5px;
    }
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 15px -1px 5px 0;
  padding: 40px 0;
  background: 1px solid rgba(97 97 97 / 30%);
`;

export const InformativeDivider = styled(Divider)`
  margin: 10px -1px 10px 0;
  background-color: #ffffff;
`;

export const BirthDayList = styled(Grid)`
  padding-left: 15px;
`;

export const ManServBanner = styled.div`
  /* border: 1px solid rgba(97 97 97 / 30%); */
  box-shadow: none;
  border-radius: 5px;
  margin: 20px 15px 20px;
  @media only screen and (max-width: 600px) {
    margin: 20px 8px 20px;
  }
`;

export const ButtonsBannerGrid = styled(Grid)`
  cursor: pointer;
  padding: 10px 0px;
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.main};
  p {
    font-size: 16px;
  }
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    background: white;
  }
  @media only screen and (max-width: 480px) {
    img {
      width: 80%;
    }
  }
`;

export const BirthDayModal = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  color: #f49649;
  padding: 50px 0;
  svg {
    font-size: 120px;
  }
  h5 {
    font-weight: bold;
    font-size: 42px;
    line-height: 0.6;
    b {
      font-size: 140px;
    }
  }
  h4 {
    font-weight: bold;
    font-size: 42px;
    text-align: center;
    line-height: 0.9;
    b {
      font-size: 100px;
    }
  }
`;

export const IconBanner = styled.div`
  height: 22px;
  padding-bottom: 5px;
  svg {
    height: 22px;
  }
  p {
    font-size: 28px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.secondary.main};
    font-weight: bold;
    line-height: 1;
  }
`;

export const NameBirthday = styled.span`
  text-transform: capitalize;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30ch;
  color: ${({ theme }) => theme.palette.primary.main};
  @media only screen and (max-width: 992px) {
    max-width: 20ch;
  }
`;

export const StyledIconButton = styled(IconButton)`
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const SecureTextArea = styled(Typography)`
  
  font-size: 21px;
  color: ${({ theme }) => theme.palette.secondary.main};
  padding-top: 10px;
  padding-left: 10px;
  @media only screen and (max-width: 992px) {
    font-size: 16px;
  }
`;